import script from "./QueueListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueListComponent.vue?vue&type=script&setup=true&lang=js"

import "../css/style.css?vue&type=style&index=0&id=bb8df802&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8df802"]])

export default __exports__